import { Storage } from 'aws-amplify';
import { Fragment, useEffect, useRef, useState } from 'react';
import { ProgressBar } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import Resizer from 'react-image-file-resizer';

const ImageUploader = ({ getImageUrl, imageName }) => {
    const [imgName, setImgName] = useState('')
    const [uploadProgress, setUploadProgress] = useState('')

    const isInitialMount = useRef(true);

    useEffect(() => {
            const setImageNameState = () => {
                setImgName(imageName)
            }
            
            setImageNameState()
    }, [imageName])

    const resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
            file,
            1200,
            900,
            'JPEG',
            80,
            0,
            (uri) => {
                resolve(uri);
            },
            'file'
            );
    });

    async function onChange(e) {
        const file = e.target.files[0]

        try {
            const image = await resizeFile(file)
            // Set the file name beside the custom upload button if uploaded
            setImgName(file.name)

            //Upload the file selected
            const uuidFileName = uuidv4() + '-hrcas3-' + file.name
            await Storage.put(uuidFileName, image, {
                progressCallback(progress) {
                    const loaded =  progress.loaded
                    const total = progress.total
                    let percent = Math.floor((loaded*100)/total)

                    if (percent < 100) {
                        setUploadProgress(percent)
                    } else if (percent === 100) {
                        setUploadProgress(100)
                        setTimeout(() => {
                            setUploadProgress('')
                        }, 1000)
                    }
                }
            })
            //Retrieve the signed URL of the uploaded file for preview
            const signedUrl = await Storage.get(uuidFileName)
            getImageUrl(uuidFileName, signedUrl)

            if(imageName) {
                setImgName(file.name)
            }
        } catch(err) {
            console.log(err)
        }
    }

    return (
        <Fragment>
            { imgName ?
                <Fragment> 
                    <label className='btn btn-primary' style={{ width: '10rem', display: 'inline-block' }}>
                        Choose File
                    <input
                        type='file'
                        onChange={onChange}
                        accept='.jpg, .jpeg, .png'
                        style={{ display: 'none', marginRight: '5px', width: '122px', color: 'transparent'}}
                        id='img'
                    />
                    </label>
                    {
                        imgName && 
                        <label htmlFor='img' style={{display: 'unset'}}>{imgName}</label>
                    }
                    {
                        (uploadProgress > 0 && uploadProgress < 100)?
                            <ProgressBar 
                                now={uploadProgress} 
                                label={`${uploadProgress}%`}
                                style={{marginTop: '5px'}}
                                animated 
                            />
                        :
                        uploadProgress === 100 ?
                            <ProgressBar 
                                className='custom-progress-bar'
                                now={uploadProgress} 
                                label={'100%'}
                                style={{marginTop: '5px', animation: 'none'}}
                                animated
                            />
                        :
                        null
                    }
                </Fragment>
                :
                <Fragment>
                    <label className='btn btn-primary' style={{ width: '10rem', display: 'inline-block' }}>
                        Choose File
                    <input
                        type='file'
                        onChange={onChange}
                        accept='.jpg, .jpeg, .png'
                        style={{ display: 'none' }}
                        id='img'
                    />
                    </label>
                    {
                        imgName ?
                        <label htmlFor='img' style={{display: 'unset'}}>
                            {imgName}
                        </label>
                        :
                        'No file chosen'
                    }
                    {
                        (uploadProgress > 0 && uploadProgress < 100)?
                            <ProgressBar 
                                now={uploadProgress} 
                                label={`${uploadProgress}%`}
                                style={{marginTop: '5px'}}
                                animated 
                            />
                        :
                        uploadProgress === 100 ?
                            <ProgressBar 
                                className='custom-progress-bar'
                                now={uploadProgress} 
                                label={'100%'}
                                style={{marginTop: '5px', animation: 'none'}}
                                animated
                            />
                        :
                        null
                    }
                </Fragment>
            }
        </Fragment>
    )
}

export default ImageUploader
